<template>
  <div>
    <!--顶部标题菜单-->
    <div class = "header">
      <p class = "h_title">{{txtLang[curLang]['guessOrderDetail']}}</p>
      <a @click = "back" href = "javascript:void(0)" class = "h_btn" ></a>
    </div>

    <div class=  "body">
      <div class= "b_info">
        <p class = "bi_name">{{info.home_team_name}} {{info.game_status == 2 ? (info.home_team_scope + ':' + info.away_team_scope) : 'VS'}} {{info.away_team_name}}</p>
        <div class = "bi_result">
          <div class= "lrr_4" v-if = "info.result_status == 1">W</div>
          <div class= "lrr_5" v-if = "info.result_status == 2">L</div>
          <div class= "lrr_6" v-if = "info.result_status == 3">P</div>
          <div class= "lrr_1" v-if = "info.result_status == 0">{{txtLang[curLang].rewarding}}</div>
          <div class= "lrr_2" v-if = "info.result_status == 1" v-html = "txtLang[curLang].winCoin(moneyStr(info.user_get_coin))"></div>
          <div class= "lrr_3" v-if = "info.result_status >= 4">{{txtLang[curLang].hasCancel}}</div>
        </div>
      </div>
      <div class = "b_li b_orderSn">
        <div class = "bl_l">{{txtLang[curLang].orderSn}}</div>
        <div class = "bl_r">{{info.order_id}}</div>
      </div>
      <div class = "b_li">
        <div class = "bl_l">{{txtLang[curLang].betPlayType}}</div>
        <div class = "bl_r">{{txtLang[curLang]['playType'][info.play_type_id]}}</div>
      </div>
      <div class = "b_li">
        <div class = "bl_l">{{txtLang[curLang].handicap}}</div>
        <div class = "bl_r">{{info.play_type_id != 1 ? oddsT(info.handicap,info.play_type_id) : '\\'}}</div>
      </div>
      <div class = "b_li">
        <div class = "bl_l">{{txtLang[curLang].betTypeAndOdds}}</div>
        <div class = "bl_r">{{txtLang[curLang]['playOption'][info.play_type_id][info.play_type_option_id - 1]}} {{info.play_type_option_odds}}</div>
      </div>
      <div class = "b_li">
        <div class = "bl_l">{{txtLang[curLang].betNum}}</div>
        <div class = "bl_r">{{curLang == 'kr' ? ('M코인 ' + moneyStr(info.coin) + ' 개') : (moneyStr(info.coin) + ' ' + txtLang[curLang]['mCoin'])}}</div>
      </div>
      <div class = "b_li">
        <div class = "bl_l">{{txtLang[curLang].betTime}}</div>
        <div class = "bl_r">{{dateStrPower(info.datetime)}}</div>
      </div>
      <div class = "b_li" v-if = "info.remark != false">
        <div class = "bl_l">{{txtLang[curLang].remark}}</div>
        <div class = "bl_r">{{info.remark}}</div>
      </div>
      <div class = "b_li" v-if = "info.message != false">
        <div class = "bl_l">{{txtLang[curLang].cancelOrigin}}</div>
        <div class = "bl_r bl_red">{{info.message}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  components:{},
  data () {
    return {
     info:{
        "order_id":"0",
        "game_id":"0",
        "home_team_name":"",
        "home_team_scope":0,
        "away_team_name":"",
        "away_team_scope":0,
        "play_type_id":1,
        "play_type_option_id":"1",
        "play_type_option_odds":0.81,
        "handicap":3,
        "coin":0,
        "user_get_coin":0,
        "status":1,
        "result_status":0,
        "game_status":1,
        "message":"",
        "remark":false,
        "datetime":1579242536
      }
      //info:{}
    }
  },
  methods: {
  	back(){
      this.$router.back(-1)
    },
    getInfo(){
      var token = localStorage.getItem('guess_token') == null ? '' : '&token=' + localStorage.getItem('guess_token');
      this.axios.get(this.getHost() + '/orders/detail?lan=' + this.langIndex + '&order_id=' + this.$route.query.id + token).then(
          (response)=>{
          var re = response.data;
          if(re.code == 200){
            this.info = re.data;
          }
          else if(re.code == 401){
            this.gotoLogin();
          }
          else{
            alert(re.message);
          }
      }).catch((response)=>{
        console.log(response);
      });
    },
  },
  created(){
  	//控制台查看变量
    //window.vueVar = this;
    this.getInfo();
  }
}
</script>

<style scoped>
/*头部*/
.header{z-index:100;position:fixed;top:0;left:0;width:100%;height:120px;background:#232048}
.header .h_title{font-size:40px;color:#fff;line-height:120px;text-align:center}
.header .h_btn{width:120px;height:120px;position:absolute;top:0;left:0}
.header .h_btn:after{display:block;content:'';width:24px;height:24px;margin-top:-12px;margin-left:-12px;border-top:4px solid #fff;border-left:4px solid #fff;position:absolute;top:50%;left:50%;transform:rotate(-45deg);-webkit-transform:rotate(-45deg);-moz-transform:rotate(-45deg);-ms-transform:rotate(-45deg);-o-transform:rotate(-45deg);}

.body{padding:120px 50px}
.body .b_info{padding:40px 0}
.body .b_info .bi_name{font-size:30px;color:#fff;line-height:36px;padding-top:30px;padding-bottom:14px}
.body .b_info .bi_result{height:40px}
.body .b_info .bi_result div{display:inline-block;vertical-align:middle}
.body .b_info .bi_result .lrr_1{color:#fff;background:#626080;border-radius:6px;padding:0 8px}
.body .b_info .bi_result .lrr_2{color:#fd7446;}
.body .b_info .bi_result .lrr_2 b{font-size:24px}
.body .b_info .bi_result .lrr_3{color:#3b3860;background:#626080;border-radius:6px;padding:0 8px}
.body .b_info .bi_result .lrr_4{font-size:24px;border-radius:200px;color:rgba(255,255,255,0.7);width:40px;height:40px;background:#e74f6b;text-align:center;line-height:40px}
.body .b_info .bi_result .lrr_5{font-size:24px;border-radius:200px;color:rgba(255,255,255,0.7);width:40px;height:40px;background:#00d9cd;text-align:center;line-height:40px}
.body .b_info .bi_result .lrr_6{font-size:24px;border-radius:200px;color:rgba(255,255,255,0.7);width:40px;height:40px;background:#5d8ef9;text-align:center;line-height:40px}

.body .b_li{border-top:2px solid #232048;color:#fff;font-size:0}
.body .b_li div{display:inline-block;vertical-align:top;width:50%;padding-top:30px;}
.body .b_li .bl_l{color:#65637f;font-size:24px;line-height:80px;height:80px}
.body .b_li .bl_r{text-align:right;font-size:24px;height:auto;line-height:40px;padding-top:60px;padding-bottom:20px;color:#fff}
.body .b_li .bl_red{color:#fb5051}
.body .b_orderSn .bl_l{width:30%}
.body .b_orderSn .bl_r{width:70%}

</style>



// WEBPACK FOOTER //
// src/components/guessOrderDetail.vue